export default "__VITE_ASSET__2kIRyWd6__"